import { useEffect, useState } from "react";
import api from "@/lib/api";
import { SectionTitle } from "@/components/GlassBits";
import { formatDate } from "@/lib/format";

export default function WebhookLogs() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  useEffect(() => { (async () => setItems((await api.get("/admin/webhook-logs")).data))(); }, []);

  return (
    <div>
      <SectionTitle eyebrow="Razorpay" title="Webhook Logs" />
      <div className="grid lg:grid-cols-3 gap-4">
        <div className="lg:col-span-1 ldc-glass p-2 max-h-[70vh] overflow-y-auto ldc-scroll">
          {items.length === 0 && <div className="p-6 text-center text-white/50">No webhooks yet.</div>}
          {items.map((w) => (
            <button key={w.id} onClick={() => setSelected(w)} data-testid={`wh-item-${w.id}`}
              className={`w-full text-left px-3 py-3 rounded-md text-sm border transition-colors mb-1 ${selected?.id === w.id ? "bg-white/5 border-[#fbce18]/40" : "border-transparent hover:bg-white/5"}`}>
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs text-[#fbce18]">{w.event}</span>
                {w.signature_valid ? <span className="ldc-badge ldc-badge-paid">valid</span> : <span className="ldc-badge ldc-badge-failed">invalid</span>}
              </div>
              <div className="text-[11px] text-white/40 mt-1">{formatDate(w.created_at)}</div>
              <div className="text-[11px] text-white/50 truncate">{w.entity_id}</div>
            </button>
          ))}
        </div>
        <div className="lg:col-span-2 ldc-glass p-5">
          {!selected ? (
            <div className="text-center py-16 text-white/40 text-sm">Select a webhook to inspect its payload.</div>
          ) : (
            <div>
              <div className="flex items-center justify-between mb-3">
                <div>
                  <div className="text-[10px] tracking-[0.28em] uppercase text-[#fbce18]/80">Event</div>
                  <div className="font-display text-lg">{selected.event}</div>
                </div>
                <div className="text-xs text-white/40">{formatDate(selected.created_at)}</div>
              </div>
              <div className="grid grid-cols-2 gap-3 text-xs">
                <Info label="Entity ID" v={selected.entity_id || "—"} />
                <Info label="Processed" v={selected.processed ? "yes" : "no"} />
                <Info label="Signature" v={selected.signature_valid ? "valid" : "invalid"} />
                <Info label="IP" v={selected.ip_address || "—"} />
              </div>
              {selected.error && <div className="mt-3 text-xs text-red-400">Error: {selected.error}</div>}
              <div className="mt-4">
                <div className="text-[10px] tracking-[0.28em] uppercase text-white/40 mb-1">Payload</div>
                <pre className="bg-black/50 rounded-md p-3 text-[11px] text-white/70 max-h-[60vh] overflow-auto ldc-scroll">{JSON.stringify(selected.payload_json, null, 2)}</pre>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
function Info({ label, v }) {
  return (
    <div className="p-2 bg-white/5 rounded">
      <div className="text-[10px] tracking-[0.2em] uppercase text-white/40">{label}</div>
      <div className="text-white/80 mt-1 break-all">{v}</div>
    </div>
  );
}
